var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ExprTag } from "@easyquery/core";
import { CustomListExpressionRenderer } from "./list_expression_renderer";
var BindToParentColumnExpressionRenderer = /** @class */ (function (_super) {
    __extends(BindToParentColumnExpressionRenderer, _super);
    function BindToParentColumnExpressionRenderer(panel, expression, editor, slot) {
        var _this = _super.call(this, panel, expression, editor, slot) || this;
        _this.expression.tag = ExprTag.ParentColumn;
        return _this;
    }
    BindToParentColumnExpressionRenderer.prototype.fillMenuItemsList = function (onComplete) {
        var query = this.panel.getQuery().getParentQuery();
        var parent = this.expression.getParent();
        var attrDataType = parent.expressions[0].dataType;
        this.menuItemsList = query
            .getColumns()
            .filter(function (col) { return col.expr.dataType == attrDataType; })
            .map(function (col) {
            return { id: col.id, text: col.caption };
        });
        if (onComplete) {
            onComplete();
        }
    };
    return BindToParentColumnExpressionRenderer;
}(CustomListExpressionRenderer));
export { BindToParentColumnExpressionRenderer };
//# sourceMappingURL=bind_to_parent_column_expression_renderer.js.map